import FlyerPreviewContainer from '../../FlyerPreview/cont/index'

const FylerPreviewAll = ({
    activeWeek,
    printType,
    printFormat,
    landscape,
    currentCinemaId,
    flyerServerData,
    flyerData,
}) => {
    return (
        <div className="flyer-preview-all">
            {['outside', 'inside'].map(side => (
                <div className={"preview-allsections " + side} key={side}>
                    {['left', 'middle', 'right'].map(section => (
                        <FlyerPreviewContainer
                            key={side + section}
                            activeWeek={activeWeek}
                            section={section}
                            side={side}
                            printType={printType}
                            flyerServerData={flyerServerData}
                            printFormat={printFormat}
                            landscape={landscape}
                            currentCinemaId={currentCinemaId}
                            flyerData={flyerData}
                            iconsColor='light'
                        />
                    ))}
                </div>
            ))}
        </div>
    )
}

export default FylerPreviewAll